import { Card } from 'react-bootstrap';
import styled from 'styled-components';
import lightStaticImage from "../../../images/fallbackMapStatic/lightStaticImage.png"
import darkStaticImage from "../../../images/fallbackMapStatic/darkStaticImage.png"
import { useSelector } from 'react-redux';
import { RootState } from '../../../state/store';
import { getEnvValueFor } from '../../../helpers/utils';

const FallbackMapView = ({ onSwitchView }) => {
  const theme = useSelector((state: RootState) => state.theme.mode);

  return (
    <Wrapper>
      <div
        className={`blurred-background ${theme === "dark" ? "dark" : "light"}`}
      />
      <div className="overlay">
        <Card className="text-center">
          <Card.Body>
            <Card.Title className="mb-2">
              <strong>Map Unavailable</strong>
            </Card.Title>
            <Card.Text className="text-muted mb-3" style={{ fontSize: "16px" }}>
              {`Please update your Geolocation in `}
              <a
                href={`${getEnvValueFor("SAPAAD_CORE_BASE_URL")}/setup_locations`}
                target="_blank"
                rel="noreferrer">{`Sapaad > Setup > Location settings > {Location} >  `}</a>
              {`General details to view this data on a visual geo-map.`}
            </Card.Text>
            <Card.Link
              style={{ fontSize: "16px" }}
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onSwitchView?.();
              }}>
              Switch to Bar Chart
            </Card.Link>
          </Card.Body>
        </Card>
      </div>
    </Wrapper>
  );
};

export default FallbackMapView;

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 0.5rem;
  overflow: hidden;

  .blurred-background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    &.dark {
      background-image: url(${darkStaticImage});
    }
    &.light {
      background-image: url(${lightStaticImage});
    }
    background-size: cover;
    background-position: center;
    opacity: 0.5;
    filter: blur(1px);
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .card {
    max-width: 400px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .card-link {
    color: #0d6efd;
    text-decoration: none;
    
    &:hover {
      color: #0a58ca;
      text-decoration: underline;
    }
  }
`;